import React from 'react'
import { browserHistory, Link } from 'react-router'
import './page.css'

function Page ({ children }) {
  function onClickPage (e) {
    if (e.target.tagName === 'DIV' || e.target.tagName === 'SECTION') {
      browserHistory.push('/')
    }
  }

  return (
    <article className="page" onClick={onClickPage}>
      <div className="page-inner">
        <div className="page-content">{children}</div>
      </div>
      <Link className="page-close" to="/">
        <svg className="icon" viewBox="0 0 16 16">
          <path d="M15.854 12.854L11 8l4.854-4.854a.503.503 0 0 0 0-.707L13.56.146a.5.5 0 0 0-.706 0L8 5 3.146.146a.5.5 0 0 0-.707 0L.146 2.44a.5.5 0 0 0 0 .706L5 8 .146 12.854a.5.5 0 0 0 0 .707l2.293 2.293a.5.5 0 0 0 .706 0L8 11l4.854 4.854a.5.5 0 0 0 .707 0l2.293-2.293a.5.5 0 0 0 0-.706z"/>
        </svg>
      </Link>
    </article>
  )
}

export default Page



// WEBPACK FOOTER //
// ./src/components/page.js